import "./App.css";
import SolarSystem from "./SolarSystem";

function App() {
  return <SolarSystem />;
}

export default App;
